import withIsFeatureActive from "web/core/UNSAFE_featureFlags/withIsFeatureActive";

/**
 * @typedef {object} OutputProps
 * @property {{ isFeatureActive: boolean }} requisitionList
 */

/**
 * @callback WithIsFeatureActiveHOC
 * @param {React.ComponentType<BaseProps & OutputProps>} BaseComponent
 * @returns {React.ComponentType<BaseProps>}
 * @template BaseProps
 */

/**
 * @returns {WithIsFeatureActiveHOC<BaseProps>}
 * @template BaseProps
 */
export default () => withIsFeatureActive("requisitionList", "requisitionList");
